<style>
.produtosEmPromocao {
  margin-top: 2%;
}
.produtosEmPromocao div.ofertas {
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
}
.loading {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>

<template>
  <div class="wrap-top-banner-solar" :class="produtosEmPromocao.length > 0 ? 'produtosEmPromocao' : ''" v-if="!loading">
    <div class="ofertas" v-if="produtosEmPromocao.length > 0">{{labelCampanha}}</div>
    <div :class="produtosEmPromocao.length > 0 ? 'wrap-show-advance-info-box style-1' : ''">
      <div
        id="caroussel_produtos"
        class="slide-carousel owl-carousel style-nav-1 caroussel_homepage"
        data-items="1"
        data-loop="1"
        data-nav="true"
        data-lazyload="true"
        data-slidespeed="1500"
        data-paginationSpeed="500"
        data-dots="true"
        data-autoplay="true"
      >
        <div v-for="(group, index) in chunkArray(produtosEmPromocao, 4)" :key="index" class="item-slide">
          <div class="row">
            <!-- Iterando sobre os produtos dentro do grupo -->
            <div class="col-md-3" v-for="(product, index) in group" :key="index">
              <Product :product="product" :carousel="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="wrap-top-banner-solar produtosEmPromocao loading">
    <Loader/>
  </div>
</template>

<script>
import axios from 'axios'
import Product from './Product.vue'
import Loader from './Loader'

export default {
  name: 'ProductCarousel',
  components: {
    Product,
    Loader,
  },
  data: function () {
    return {
      loading: true,
      produtosEmPromocao: [],
      labelCampanha: 'produtos em destaque',
    }
  },
  created: function () {
    const self = this
    const session = JSON.parse(localStorage.getItem('usuarioLogado'))

    axios
      .get(self.$apiUrl + '/Produto.svc/ProdutosEmPromocao', {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.Item1) {
          self.labelCampanha = response.data.Item1
        }

        const produtos = response.data.Item2

        produtos.forEach((element) => {
          let produto = {}
          produto.id = element.produto_id
          produto.code = element.produto_id + '-' + element.prd_codigodv
          produto.name = element.psg_descricao + ' ' + element.pgr_descricao
          produto.state = 'PR'
          produto.img = element.prd_caminho
          produto.description = element.prd_descricao
          produto.url = '/loja/produto/' + produto.code + '/' + element.URL
          produto.promotionalPrice = element.prd_precode
          produto.price = element.prd_preco
          produto.showActions = true
          produto.isLogged = element.is_logged
          produto.prdQtdeUnidade = element.prd_qtdeUnid
          produto.qtd = element.prd_qtdeUnid
          produto.productSelos = element.Selos
          produto.potencia = element.potencia > 0 ? element.prd_preco / (element.potencia * 1000) : 0
          produto.gerador = element.gerador
          produto.wallbox = element.wallbox
          produto.potenciaGerador = element.prd_potenciaGerador
          produto.potenciaInversor = element.prd_potenciaInversor
          produto.mppt = element.prd_mppt
          produto.tensao = element.prd_tensao
          produto.fase = element.prd_fase
          produto.suframa = session ? session.DadosCliente.IsSuframa : ''
          produto.valorParcela = element.prd_valorParcela

          self.produtosEmPromocao.push(produto)
        })
        self.loading = false

        setTimeout(function () {
          self.startSliderSolarRotativo()
        }, 100)
      })
      .catch((error) => {
        self.loading = false
        console.log(error)
      })
  },
  methods: {
    startSliderSolarRotativo() {
      var _this = $('#caroussel_produtos'),
        _owl = _this,
        _config = _this.data(),
        _animateOut = _this.data('animateout'),
        _lazyloading = _this.data('lazyload'),
        _loop = _this.data('loop'),
        _animateIn = _this.data('animatein'),
        _slidespeed = _this.data('slidespeed'),
        _paginationSpeed = _this.data('paginationSpeed'),
        _dots = _this.data('dots')

      _config.navText = ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>']
      if (typeof _animateOut != 'undefined') {
        _config.animateOut = _animateOut
      }
      if (typeof _loop != 'undefined') {
        _config.loop = _loop
      }
      if (typeof _animateIn != 'undefined') {
        _config.animateIn = _animateIn
      }
      if (typeof _lazyloading != 'undefined') {
        _config.lazyloading = _lazyloading
      }
      if (typeof _slidespeed != 'undefined') {
        _config.smartSpeed = _slidespeed
      }
      if (typeof _paginationSpeed != 'undefined') {
        _config.paginationSpeed = _paginationSpeed
      }
      if (typeof _dots != 'undefined') {
        _config.dots = _dots
      }
      if ($('body').hasClass('rtl')) {
        _config.rtl = true
      }
      _owl.on('drag.owl.carousel', function () {
        _owl.addClass('owl-changed')
        setTimeout(
          function () {
            _owl.removeClass('owl-changed')
          },
          _config.smartSpeed,
          _config.paginationSpeed
        )
      })
      _owl.on('mouseover', function (e) {
        var data = $(e.currentTarget).data('owl.carousel')
        if (data.settings.autoplay) {
          $(e.currentTarget).trigger('stop.owl.autoplay')
        }
      })
      _owl.on('mouseleave', function (e) {
        var data = $(e.currentTarget).data('owl.carousel')
        if (data.settings.autoplay) {
          _owl.trigger('play.owl.autoplay', [5000])
        }
      })
      _owl.owlCarousel(_config)
    },
    chunkArray(array, size) {
      const chunkedArray = []
      for (let i = 0; i < array.length; i += size) {
        chunkedArray.push(array.slice(i, i + size))
      }
      return chunkedArray
    },
  },
}
</script>
